var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_4319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 12.75C3.68723 12.75 1.5 14.9372 1.5 17.625C1.5 20.3128 3.68723 22.5 6.375 22.5H17.625C20.3128 22.5 22.5 20.3128 22.5 17.625C22.5 14.9372 20.3128 12.75 17.625 12.75H6.375ZM6.375 14.25H17.625C19.5077 14.25 21 15.7423 21 17.625C21 19.5077 19.5077 21 17.625 21H6.375C4.49228 21 3 19.5077 3 17.625C3 15.7423 4.49228 14.25 6.375 14.25Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.5C9.10939 0.5 6.75 2.85939 6.75 5.75C6.75 8.64061 9.10939 11 12 11C14.8906 11 17.25 8.64061 17.25 5.75C17.25 2.85939 14.8906 0.5 12 0.5ZM12 2C14.0799 2 15.75 3.67005 15.75 5.75C15.75 7.82995 14.0799 9.5 12 9.5C9.92005 9.5 8.25 7.82995 8.25 5.75C8.25 3.67005 9.92005 2 12 2Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_4319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8c98530dae3b582613d7c7fc36c62c2f.svg";
export { ForwardRef as ReactComponent };